import { render } from "./dialogPedido.vue?vue&type=template&id=07209392&scoped=true"
import script from "./dialogPedido.vue?vue&type=script&lang=js"
export * from "./dialogPedido.vue?vue&type=script&lang=js"

import "./dialogPedido.vue?vue&type=style&index=0&id=07209392&scoped=true&lang=css"

import exportComponent from "C:\\Projetos_Somasys\\Delivery\\DeliverySoma-SOLO.2023.10.27\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07209392"]])

export default __exports__